import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/views/main'], resolve),
      redirect: '/index',
      children: [
        {
          path: '/index',
          component: resolve => require(['@/views'], resolve)
        },
        {
          path: '/service',
          component: require('@/views/service.vue').default
        },
        {
          path: '/goods',
          component: require('@/views/goods.vue').default
        },
        {
          path: '/pay',
          component: require('@/views/pay.vue').default
        },
        {
          path: '/order',
          component: require('@/views/order.vue').default
        },
        {
          path: '/accomplish',
          component: require('@/views/payAccomplish.vue').default
        },
        {
          path: '/modify',
          component: require('@/views/modify.vue').default
        }
      ]
    },
    {
      path: '/login',
      component: require('@/views/login.vue').default
    },
    {
      path: '/register',
      component: require('@/views/register.vue').default
    },
    {
      path: '/forget',
      component: require('@/views/forget.vue').default
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// const whiteList = ['/login', '/register', '/forget']

// 导航守卫，渲染动态路由
// router.beforeEach((to, from, next) => {
//   if (whiteList.indexOf(to.path) !== -1) {
//     if (router.app.$cookies.get('h5_user') && router.app.$cookies.get('h5_token')) {
//       next('/')
//     } else {
//       next()
//     }
//   } else {
//     if (router.app.$cookies.get('h5_user') && router.app.$cookies.get('h5_token')) {
//       next()
//     } else {
//       // next('/login')
//       next()
//     }
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js